import { NgModule } from '@angular/core';
import { ClMalwareModule } from 'app/components/malware/malware.module';
import { GroupActionsComponent } from './group-actions.component';
import { RestoreFromBackupActionComponent } from './restore-from-backup-action.component';
import { CleanupActionComponent } from 'app/components/malware/actions/cleanup-action.component';
import { RestoreFromQuarantineActionComponent } from './restore-from-quarantine-action.component';
import {
    RestoreOriginalActionComponent,
} from 'app/components/malware/actions/restore-original-action.component';
import { ViewFileActionComponent } from 'app/components/malware/actions/view-file-action.component';
import { CommonModule } from '@angular/common';
import { I360TableModule } from 'app/utils/table/table.module';

const actions = [
    GroupActionsComponent,
    RestoreFromBackupActionComponent,
    RestoreFromQuarantineActionComponent,
];

@NgModule({
    imports: [
        ClMalwareModule.import({
            maliciousActions: [
                ViewFileActionComponent,
                CleanupActionComponent,
                RestoreOriginalActionComponent,
                RestoreFromQuarantineActionComponent,
                GroupActionsComponent,
            ],
        }),
        CommonModule,
        I360TableModule,
    ],
    declarations: [
        ...actions,
    ]
})
export class I360MalwareModule {}
